import { render, staticRenderFns } from "./GamificationCampaignDetail.vue?vue&type=template&id=f1b70828&scoped=true&"
import script from "./GamificationCampaignDetail.vue?vue&type=script&lang=js&"
export * from "./GamificationCampaignDetail.vue?vue&type=script&lang=js&"
import style0 from "./GamificationCampaignDetail.vue?vue&type=style&index=0&id=f1b70828&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b70828",
  null
  
)

export default component.exports